<script lang="ts" setup>
import type { PayPageConfig } from '../configs/types'
import { getPayPageConfig } from '../configs/brands'

defineProps<{
  item: any
  isActive?: boolean
}>()

// 加载当前品牌的 pay 配置
const config: PayPageConfig = getPayPageConfig()
</script>

<template>
  <div class="purchase-item-content relative w-full h-full flex flex-col items-center justify-center">
    <!-- 营销文案标签 -->
    <div
      v-if="item.marketingText"
      class="marketing-tag pos-absolute !text-white left--1px top--8px min-w-50px h-16px text-10px py-2px px-2 flex items-center"
    >
      {{ item.marketingText }}
    </div>

    <!-- 金币数量 -->
    <div class="coins-amount text-n-text-1">
      <span class="text-18px font-medium">{{ item.coinsBuy }}+{{ item.coinsBonus }}</span>
      <span class="text-n-text-2 ml-1">{{ config.texts.coins || 'Coins' }}</span>
    </div>

    <!-- 价格 -->
    <div class="price text-n-text-2 mt-2px">
      $ {{ item.price }}
    </div>
  </div>
</template>

<style scoped>
.purchase-item-content {
  padding: 12px 8px;
}

.marketing-tag {
  background: linear-gradient(132deg, #F961BC 0%, #F74984 100%);
  border-radius: 100px 100px 100px 0px;
}
</style>
